module.exports = __webpack_public_path__ + "static/media/im11.1913b1de.png";